import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { MyCalendar, CircularProgress } from '../../../common'
import OfflineModeHeader from '../../../containers/OfflineModeHeader'
import LaundryBookingItems from '../../../containers/LaundryBookingItems'
import MenuHeader from '../../../containers/MenuHeader'

import * as Strings from './strings'
import * as Styles from './styles'
import * as Functions from '../../../../helpers/Functions'
import * as Constants from '../../../../helpers/Constants'
import * as configActions from '../../../../actions/Config'
import * as laundryBookingActions from '../../../../actions/LaundryBookings'
import * as offlineModeActions from '../../../../actions/OfflineMode'

const TODAY = new Date()

class LaundryBooking extends Component {
  constructor(props) {
    super(props)
    this.state = {
      chosenDate: TODAY,
      dateTimeFormat: null,
      width: window.innerWidth
    }

    this.resizeHandler = this.resizeHandler.bind(this)
  }

  componentDidMount() {
    const { history, user, offlineMode, data, language } = this.props

    if (offlineMode) {
      if (!user.offlineModeSignedIn) {
        this.props.setOfflineSetup()
      }
    } else if (!user.fetched) {
      history.push('/')
    } else if (!data.laundrySystemFetched) {
      this.props.tryGetLaundrySystem(user.token, language, (h, i, t, b) =>
        this.props.showAlert(h, i, t, b)
      )
    }

    window.addEventListener('resize', this.resizeHandler)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler)
  }

  resizeHandler() {
    this.setState({ width: window.innerWidth })
  }

  getString(key) {
    const { language } = this.props

    return Functions.getString(key, language)
  }

  handleChangeDate = (event, date) => {
    this.setState({ chosenDate: date })
  }

  renderCalendarBooking() {
    const { offlineMode } = this.props
    const { width, chosenDate } = this.state
    const { bookingsContainer } = Styles.default

    if (width > 937)
      return (
        <div style={{ ...bookingsContainer, marginTop: offlineMode ? 65 : 25 }}>
          <LaundryBookingItems date={chosenDate} offlineMode={offlineMode} />
        </div>
      )
    return <LaundryBookingItems date={chosenDate} offlineMode={offlineMode} />
  }

  renderCalendar() {
    const { data, offlineMode } = this.props
    const { width, chosenDate } = this.state
    const allBookings = []
    const today = new Date()
    let timesLeftToday = 0
    this.props.data.laundryTimes.map(time => {
      if (parseInt(time.endTime.split(':')[0]) > parseInt(today.getHours()))
        timesLeftToday++
      time.bookings.forEach(booking => allBookings.push(booking))
    })

    const availability = {}
    const availabilityStatus = {}
    allBookings.forEach(booking => {
      if (availability[booking.date]) {
        const bookingDate = new Date(booking.date)
        availability[booking.date] = availability[booking.date] + 1
        if (
          (Functions.compareDate(bookingDate, new Date()) &&
            availability[booking.date] >=
              timesLeftToday * this.props.data.laundries.length) ||
          availability[booking.date] >=
            this.props.data.laundryTimes.length *
              this.props.data.laundries.length
        )
          availabilityStatus[booking.date] = 'red'
      } else {
        availability[booking.date] = 1
        if (timesLeftToday * this.props.data.laundries.length === 1)
          availabilityStatus[booking.date] = 'red'
      }
      if (booking.apartment && booking.apartment.id === data.apartment.id) {
        availabilityStatus[booking.date] = 'green'
      }
    })

    const containerStyle =
      width > 937
        ? Styles.default.fullScreenCalendarContainerStyle
        : Styles.default.halfScreenCalendarContainerStyle

    let maxDate = new Date()
    if (data.laundryRules && data.laundryRules.bookingRange !== 0) {
      maxDate.setDate(maxDate.getDate() + 7 * data.laundryRules.bookingRange)
    } else {
      maxDate = null
    }

    const startDate = new Date(data.laundryRules.startDate)
    let minDate = TODAY

    if (startDate.getTime() > TODAY.getTime()) {
      minDate = startDate
    }
    return (
      <div style={{ ...containerStyle, marginTop: offlineMode ? 65 : 25 }}>
        <MyCalendar
          ref={'calendar'}
          onChange={(event, date) => {
            this.handleChangeDate(event, date)
          }}
          minDate={minDate}
          maxDate={maxDate}
          chosenDate={chosenDate}
          availabilityStatus={availabilityStatus}
          locale={this.getString('calendarLanguage')}
        />
      </div>
    )
  }

  getContainerStyle() {
    const { width } = this.state
    return {
      display: 'flex',
      alignItems: width > 937 ? 'flex-start' : 'center',
      flexDirection: width > 937 ? 'row' : 'column',
      minHeight: '100vh',
      marginTop: 100
    }
  }

  renderContent() {
    const { user, data } = this.props

    if (!user.fetched || !data.laundrySystemFetched) {
      return <CircularProgress />
    }

    return (
      <div>
        <div style={this.getContainerStyle()}>
          {this.renderCalendar()}
          {this.renderCalendarBooking()}
        </div>
      </div>
    )
  }

  render() {
    const { language, user, history, offlineMode } = this.props

    if (!user.fetched && !offlineMode) {
      history.push('/')
    }

    return (
      <MenuHeader
        history={history}
        header={Strings.default.BOOK_LAUNDRY[language]}
        selected={Constants.BOOK_LAUNDRY_FOCUSED}
      >
        <OfflineModeHeader history={history} />
        {this.renderContent()}
      </MenuHeader>
    )
  }
}

function mapStateToProps({ user, config, data, users }) {
  const { language } = config
  return { user, data, language, users, config }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...offlineModeActions, ...configActions, ...laundryBookingActions },
    dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(LaundryBooking)



// WEBPACK FOOTER //
// ./src/components/pages/laundries/LaundryBooking/index.js